// Module
var code = "<runner-page-description is-show=\"!isMobile\" page-header-text=\"Setup\" page-description=\"Create and manage users in {{$ctrl.businessName}}.\" help-link=\"{{$ctrl.helpUri}}\"> <users-header></users-header> </runner-page-description> <runner-setup-tabs></runner-setup-tabs> <setup-users></setup-users> ";
// Exports
export default code;